/* TST - ALT media groups. Works alongside the theme's native variant and slider events. */
(() => {
  const normalize = (value) => (value || '').trim().toLocaleLowerCase();
  const mediaItems = (root) => Array.from(root?.querySelectorAll(':scope > li[data-media-id]') || []);
  const thumbItems = (root) => Array.from(root?.querySelectorAll(':scope > li[data-target]') || []);

  function syncSlider(component, visibleItems) {
    if (!component) return;
    // Dawn's slider-component caches sliderItems at initialization.
    // Synchronize its cache so page counting and next/previous use visible slides.
    component.sliderItems = visibleItems;
    if (typeof component.initPages === 'function') component.initPages();
    else if (typeof component.update === 'function') component.update();
  }

  function updateCounter(gallery, activeId, visible) {
    const viewer = gallery.elements?.viewer;
    if (!viewer) return;
    const index = Math.max(0, visible.findIndex((item) => item.dataset.mediaId === activeId));
    const current = viewer.querySelector('.slider-counter--current');
    const total = viewer.querySelector('.slider-counter--total');
    if (current) current.textContent = String(index + 1);
    if (total) total.textContent = String(visible.length);
  }

  function apply(gallery, mediaId) {
    if (!gallery || gallery.dataset.tstAltGrouping !== 'true') return;
    const viewer = gallery.elements?.viewer || gallery.querySelector('[id^="GalleryViewer"]');
    const thumbs = gallery.elements?.thumbnails || gallery.querySelector('[id^="GalleryThumbnails"]');
    const viewerList = viewer?.querySelector('[id^="Slider-Gallery"]');
    const thumbList = thumbs?.querySelector('[id^="Slider-Thumbnails"]');
    if (!viewerList) return;

    const all = mediaItems(viewerList);
    const selected = all.find((item) => item.dataset.mediaId === mediaId) ||
      all.find((item) => item.dataset.mediaId?.endsWith(`-${gallery.dataset.tstFeaturedId}`));
    const key = normalize(selected?.dataset.tstMediaAlt);
    // No matching variant media/ALT: show everything to prevent an empty gallery.
    const visible = all.filter((item) => !key || !normalize(item.dataset.tstMediaAlt) ||
      normalize(item.dataset.tstMediaAlt) === key);

    all.forEach((item) => {
      const hidden = !visible.includes(item);
      item.classList.toggle('tst-media-group-hidden', hidden);
      item.setAttribute('aria-hidden', String(hidden));
      if (hidden) item.classList.remove('is-active');
    });

    const thumbnails = thumbItems(thumbList);
    const allowed = new Set(visible.map((item) => item.dataset.mediaId));
    const visibleThumbs = thumbnails.filter((item) => allowed.has(item.dataset.target));
    thumbnails.forEach((item) => {
      const hidden = !allowed.has(item.dataset.target);
      item.classList.toggle('tst-media-group-hidden', hidden);
      item.setAttribute('aria-hidden', String(hidden));
      const button = item.querySelector('button');
      if (button) {
        button.tabIndex = hidden ? -1 : 0;
        if (hidden) button.removeAttribute('aria-current');
      }
    });

    const active = visible.find((item) => item.dataset.mediaId === mediaId) || visible[0];
    if (!active) return;
    active.classList.add('is-active');
    if (thumbs) {
      const activeThumb = visibleThumbs.find((item) => item.dataset.target === active.dataset.mediaId);
      if (activeThumb) {
        visibleThumbs.forEach((item) => item.querySelector('button')?.removeAttribute('aria-current'));
        activeThumb.querySelector('button')?.setAttribute('aria-current', 'true');
      }
    }

    syncSlider(viewer, visible);
    syncSlider(thumbs, visibleThumbs);
    updateCounter(gallery, active.dataset.mediaId, visible);

    // Keep the native slider on the active media without moving the page vertically.
    requestAnimationFrame(() => {
      if (!gallery.isConnected || gallery.querySelector('.is-active') !== active) return;
      viewerList.scrollTo({ left: active.offsetLeft, behavior: 'instant' });
    });
    gallery.dataset.tstCurrentMediaId = active.dataset.mediaId;
  }

  function install(gallery) {
    if (gallery.dataset.tstAltGrouping !== 'true') return;
    gallery.applyTstVariantMediaGroup = (mediaId) => apply(gallery, mediaId);
    const sectionId = gallery.id.replace(/^MediaGallery-/, '');
    const initial = gallery.dataset.tstFeaturedId
      ? `${sectionId}-${gallery.dataset.tstFeaturedId}` : null;
    apply(gallery, initial);
  }

  const initialize = () => document.querySelectorAll('media-gallery[data-tst-alt-grouping="true"]').forEach(install);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
